import { useSelector } from "react-redux";
import Swal from "sweetalert2";

export default async function submitForm({
  url,
  method = "POST",
  data,
  proxy,
  lang,
  inputFields,
}) {
  const DATA = data.data;

  for (const field of inputFields) {
    const { alias, required , isNotCheckRequire} = field;

    if (required && !DATA?.[alias] && !isNotCheckRequire) {
      const errorMessage = `${field.name} không được trống!`;

      await Swal.fire({
        title: lang["error"] || "Error",
        text: errorMessage,
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "OK",
        allowOutsideClick: false,
      });
      return false;
    }
  }

  const token = localStorage.getItem("_token");
  try {
    Swal.fire({
      title: `Đang ${method === "POST" ? "tạo" : "cập nhật"} dữ liệu...`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    const response = await fetch(proxy() + url, {
      method,
      headers: {
        Authorization: token,
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    const { success, message } = result;

    if (success) {
      await Swal.fire({
        title: lang?.["success"] || "Success",
        text:
          lang?.[message] || method === "POST"
            ? lang?.["success.add"]
            : lang?.["success.update"],
        icon: "success",
        showConfirmButton: false,
        timer: 1500,
      });
    } else {
      await Swal.fire({
        title:
          method === "POST"
            ? lang?.["fail.add"]
            : lang?.["fail.update"] || "Update failed",
        html: `<div style="white-space: pre-line;">${
          lang?.[message] || message
        }</div>`,
        icon: "error",
        showConfirmButton: true,
      });
    }

    return success;
  } catch (error) {
    console.error("Submit error:", error);
    Swal.fire({
      title:
        method === "POST"
          ? lang?.["fail.add"]
          : lang?.["fail.update"] || "Update failed",
      text: error.message,
      icon: "error",
      showConfirmButton: true,
    });
    return false;
  }
}
